import { render } from "./App.vue?vue&type=template&id=5c2cc81d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5c2cc81d&lang=css"

import exportComponent from "C:\\servers\\develope\\coinview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__